import { render } from "./Identity.vue?vue&type=template&id=95759ce4"
import script from "./Identity.vue?vue&type=script&lang=js"
export * from "./Identity.vue?vue&type=script&lang=js"
script.render = render

export default script